export default __webpack_public_path__ + "static/media/JS.ca691704.png";